module.exports = __webpack_public_path__ + "fonts/work-sans-v4-latin-ext-regular.f54f2fe9.ttf";